import { AuditTrailView } from "@/features/admin/audit-trail/components/AuditTrailView";

export function AuditTrailPage() {
  return <AuditTrailView />;
}
